import { getToken } from "../Apimanager/Networking";

export const refreshReduxStoreOnboard = async (getProviderData) => {
   const token = await getToken();
   if (!token) {
      return;
   }
   try {
      getProviderData(null, true);

   } catch (error) {
      console.log(error);
   }
};
